var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth-container"}},[_c('AuthHeader'),_c('div',{attrs:{"id":"auth-body"}},[_c('AuthForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }